<template>
  <div class="patient-call-card">
    <div class="patient-call-card__header">
      <div class="patient-call-card__header__row">
        <div class="patient-call-card__header__title">{{ title }}</div>
        <div class="patient-call-card__header__labels">
          <div
            class="patient-call-card__header__label"
            v-for="label in labels"
            v-bind:key="label"
            v-bind:class="label"
          />
        </div>
      </div>
      <div class="patient-call-card__header__phone">{{ phone }}</div>
    </div>
    <button
      class="patient-call-card__event"
      type="button"
      v-bind:key="`${event.type}-${event.id}`"
      v-for="event in events"
    >
      <router-link
        class="patient-call-card__event__title"
        v-bind:to="makeNavigationToEvent(event)"
      >{{ event.title }}</router-link>
      <div v-if="event.description" class="patient-call-card__event__description">
        {{ event.description }}
      </div>
    </button>
    <button
      v-if="isShowCreateAppointmentButton"
      v-on:click="onCopyPatient"
      class="patient-call-card__action"
      type="button"
    >
      Записать на прием
    </button>
    <button
      v-if="isShowCreatePatientButton"
      v-on:click="onOpenCreationPatientForm"
      class="patient-call-card__action"
      type="button"
    >
      Создать пациента
    </button>
    <button
      v-if="isShowSelectPatientButton"
      v-on:click="onSelectPatient"
      class="patient-call-card__action"
      type="button"
    >
      Выбрать
    </button>
  </div>
</template>

<script>

const NAME_EVENT_COPY_PATIENT = 'copy-patient';
const NAME_EVENT_OPEN_PATIENT_CREATION_FORM = 'open-patient-creation-form';
const NAME_EVENT_SELECT_PATIENT = 'select-patient';

const ACTION_CREATE_PATIENT = 'create-patient';
const ACTION_CREATE_APPOINTMENT = 'create-appointment';
const ACTION_SELECT_PATIENT = 'select-patient';

/**
 * @description Компонент карточки входящего звонка.
 * @type {Vue}
 */
export default {
  computed: {
    isShowCreateAppointmentButton() {
      return this.actions.includes(ACTION_CREATE_APPOINTMENT);
    },
    isShowCreatePatientButton() {
      return this.actions.includes(ACTION_CREATE_PATIENT);
    },
    isShowSelectPatientButton() {
      return this.actions.includes(ACTION_SELECT_PATIENT);
    },
  },
  methods: {
    /**
     * @description Создать навигацию до события.
     * @type {Object} event
     * @returns {Object}
     */
    makeNavigationToEvent(event) {
      if (event.type === 'appointment') {
        return {
          name: 'ClinicPanelAppointmentScheduleEmployeePeriod',
          params: {
            id: event.employee_id,
          },
          query: {
            day: event.day,
            appointment: event.id,
          },
        };
      }
      if (event.type === 'waiting') {
        const query = {
          day: event.day,
          waiting: event.id,
        };
        const name = event.employee_id
          ? 'ClinicPanelAppointmentScheduleEmployeePeriod'
          : 'ClinicPanelAppointmentScheduleEmployees';
        const id = event.employee_id ? event.employee_id : null;
        return {
          name,
          params: { id },
          query,
        };
      }
      return {};
    },
    onCopyPatient() {
      this.$emit(NAME_EVENT_COPY_PATIENT, this.patientId);
    },
    onOpenCreationPatientForm() {
      this.$emit(NAME_EVENT_OPEN_PATIENT_CREATION_FORM);
    },
    onSelectPatient() {
      this.$emit(NAME_EVENT_SELECT_PATIENT, this.patientId);
    },
  },
  name: 'PatientCallCard',
  props: {
    actions: { required: true, type: Array },
    events: { default: () => [], type: Array },
    labels: { default: () => [], type: Array },
    patientId: { default: () => null, type: Number },
    title: { required: true, type: String },
    phone: { required: true, type: String },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.patient-call-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 14px;
  background-color: #ffffff;
  border-bottom: 1px solid #EAEFF3;
  &:last-child {
    border-bottom: none;
  }
  &__action {
    @include buttons.btn-transparent(177px, 32px, 14px);
  }
  &__header {
    display: flex;
    flex-direction: column;
    &__row {
      display: flex;
      flex-flow: row wrap;
      gap: 4px;
      align-items: center;
      justify-content: space-between;
    }
    &__title {
      color: var(--action-color);
      font-size: 14px;
      display: block;
      width: 100%;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    &__labels {
      display: flex;
      flex-direction: row;
      gap: 6px;
    }
    &__label {
      align-self: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 16px;
      height: 16px;
      margin: 0;
      padding: 0;
      &.black-list {
        background-image: url("@/assets/img/black-list-grey.svg");
      }
      &.unwanted {
        background-image: url("@/assets/img/mad-grey.svg");
      }
      &.archive {
        background-image: url("@/assets/img/archive-add-grey.svg");
      }
    }
    &__phone {
      color: #192A3E;
      font-size: 16px;
    }
  }
  &__event {
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-align: left;
    &__title {
      display: block;
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &:hover {
        text-decoration: underline;
      }
    }
    &__description {
      color: #707683;
    }
  }
}
</style>
